<template>
  <b-modal
    modal-class="component-modal-itemItem"
    id="ItemItemModal"
    ref="ItemItemModal"
    size="xl fluid"
    title="รายการยา และสินค้า"
    hide-footer
    no-close-on-backdrop
    @close="close"
    @hide="close"
    @hidden="setDefaultValue"
  >
    <b-form @submit.prevent="saveDrugsItem">
      <div
        :class="{
          'disabled-medicine-form':
            isAccessMenu(['ROLE_BRANCH_STOCK_MANAGER', 'ROLE_STOCK_STAFF']) &&
            !isHeadCounterOrManager,
        }"
      >
        <b-form-group label-cols="3" label="รหัส:" label-align="right">
          <b-form-input v-model="itemItem.code"></b-form-input>
        </b-form-group>
        <b-form-group
          label-cols="3"
          label="ชื่อรายการ(ไทย):"
          label-align="right"
        >
          <b-form-input
            v-model="itemItem.nameTh"
            class="required"
            :class="{ 'is-invalid': $v.itemItem.nameTh.$error }"
          >
          </b-form-input>
        </b-form-group>
        <b-form-group
          label-cols="3"
          label="ชื่อรายการ(Eng):"
          label-align="right"
        >
          <b-form-input v-model="itemItem.nameEn"></b-form-input>
        </b-form-group>
        <b-form-group label-cols="3" label="ราคา" label-align="right">
          <b-form-input
            v-model="itemItem.price"
            class="required"
            number
            :class="{ 'is-invalid': $v.itemItem.price.$error }"
          >
          </b-form-input>
        </b-form-group>
        <b-form-group label-cols="3" label="ชื่อหน่วย" label-align="right">
          <b-form-input
            v-model="itemItem.unitName"
            class="required"
            :class="{ 'is-invalid': $v.itemItem.unitName.$error }"
          >
          </b-form-input>
        </b-form-group>

        <b-form-row>
          <div class="col-3 text-right align-self-center">ประเภท:</div>
          <b-form-select
            v-model="itemItem.cateId"
            class="col mx-1 required"
            :options="getItemCateList"
            value-field="id"
            text-field="nameTh"
            :class="{ 'is-invalid': $v.itemItem.cateId.$error }"
          >
            <template v-slot:first>
              <b-form-select-option :value="null" disabled
                >-- เลือกประเภท --</b-form-select-option
              >
            </template>
          </b-form-select>
          <b-button
            class="col-1 mx-1"
            block
            variant="secondary"
            @click="openDrugsCateItem()"
          >
            <i class="fas fa-edit"></i>
          </b-button>

          <!-- <b-button
          class="col-2 mx-1"
          variant="outline-info"
          :pressed="itemItem.favorite"
          @click="itemItem.favorite = !itemItem.favorite"
        >
          <i class="far fa-star">ใช้ประจำ</i>
        </b-button>-->
        </b-form-row>

        <b-form-group
          class="mt-3"
          label-cols="3"
          label="ค่าคอมมิชชั่นสินค้า:"
          label-align="right"
        >
          <b-row>
            <b-input-group class="col">
              <b-form-input
                v-model="itemItem.df"
                number
                @keyup="validateDf(itemItem.df)"
                class="required"
                :class="{ 'is-invalid': $v.itemItem.df.$error }"
              ></b-form-input>
              <template v-slot:append>
                <b-input-group-text>{{
                  itemItem.dfType === 0 ? "%" : "บาท"
                }}</b-input-group-text>
              </template>
            </b-input-group>
            <b-form-radio-group
              class="align-self-center"
              v-model="itemItem.dfType"
            >
              <b-form-radio :value="0">Percent</b-form-radio>
              <b-form-radio :value="1">Fixed</b-form-radio>
            </b-form-radio-group>
            <b-button
              v-b-toggle.dfDetail
              class="col-3 mr-3"
              variant="secondary"
              size="sm"
              >DF แพทย์แต่ละท่าน</b-button
            >
          </b-row>
        </b-form-group>
        <b-row>
          <b-col cols="3"></b-col>
          <b-col class="px-2">
            <b-collapse id="dfDetail" class="mr-2">
              <b-card>
                <div class="mb-3">
                  กรุณาเลือกแพทย์ที่ต้องการให้ DF เฉพาะท่าน
                  <br />ในกรณีที่ไม่ได้เลือก DF จะคิดเท่ากับ "DF รายการรักษา"
                </div>
                <b-row
                  class="mb-2"
                  v-for="(dfSpec, index) in itemItem.dfItem"
                  :key="dfSpec.uid"
                >
                  <b-col cols="6" class="pr-0">
                    <div class="text-right pt-1">
                      {{ getUserListBy(dfSpec.uid, "uid").fullName }} :
                    </div>
                  </b-col>
                  <b-col>
                    <b-input-group>
                      <b-input-group-prepend is-text>
                        <!-- เพิ่ม data dfActive อีกตัว?? -->
                        <b-form-checkbox
                          switch
                          v-model="dfSpec.dfActive"
                          @input="activateDfSpec(dfSpec)"
                        ></b-form-checkbox>
                      </b-input-group-prepend>
                      <b-form-input
                        number
                        v-model="dfSpec.df"
                        @keyup="validateDfItem(dfSpec, index)"
                        :disabled="!dfSpec.dfActive"
                        required
                      ></b-form-input>
                      <b-input-group-append>
                        <b-input-group-text>{{
                          itemItem.dfType === 0 ? "%" : "บาท"
                        }}</b-input-group-text>
                      </b-input-group-append>
                    </b-input-group>
                  </b-col>
                </b-row>
              </b-card>
            </b-collapse>
          </b-col>
        </b-row>
      </div>
      <hr />

      <div class="display-column">
        <div class="d-flex flex-column">
          <div class="label-title">ผูกเข้ากับคลัง</div>
          <div class="label-description">
            ผูกยาและสินค้าเข้ากับคลัง
            เพื่อกำหนดรายการสินค้าที่ต้องถูกตัดสต๊อกเมื่อมีการใช้งาน
            (สามารถผูกได้มากกว่า 1 รายการ เช่น กรณีเป็นแพ็กเกจ)
          </div>
        </div>
        <template v-if="drugStockBinding.length > 0">
          <b-table
            id="DrugStockBindingTable"
            ref="DrugStockBindingTable"
            hover
            small
            sort-icon-left
            head-variant="light"
            :items="drugStockBinding"
            :fields="fields"
          >
            <template v-slot:cell(index)="row">
              <div class="d-flex align-items-center justify-content-center">
                {{ row.index + 1 }}.
              </div>
            </template>

            <template v-slot:cell(productNoAndName)="row">
              <div class="product-no-and-name-wrapper">
                <multiselect
                  class="col p-0 required"
                  v-model="row.item.productNoAndName"
                  :options="getProductOptions(row.index)"
                  :multiple="false"
                  placeholder="เลือกสินค้า"
                  @input="onProductNoAndNameChange(row)"
                  track-by="id"
                  :custom-label="item => item.name || ''"
                  selectLabel="เลือกสินค้า"
                  selectedLabel="เลือกแล้ว"
                  deselectLabel="คลิกเพื่อลบออก"
                  openDirection="below"
                  :class="{
                    'is-invalid':
                      $v.drugStockBinding.$each[row.index] &&
                      $v.drugStockBinding.$each[row.index].productNoAndName
                        .$error,
                  }"
                  :disabled="!isAccessMenu(['ROLE_BRANCH_STOCK_MANAGER'])"
                >
                  <span slot="noResult">ไม่พบรายการ แนะนำเปลี่ยนคำค้นหา</span>
                </multiselect>
                <template
                  v-if="
                    $v.drugStockBinding.$each[row.index] &&
                    $v.drugStockBinding.$each[row.index].productNoAndName.$error
                  "
                >
                  <div class="invalid-icon-position">
                    <i class="icon-invalid-exclamation"></i>
                  </div>
                </template>
              </div>
            </template>

            <template v-slot:cell(productAmount)="row">
              <b-form-input
                v-model="row.item.productAmount"
                class="required"
                placeholder="กรอกจำนวน"
                inputmode="numeric"
                maxlength="10"
                :disabled="
                  !row.item.productNoAndName ||
                  !isAccessMenu(['ROLE_BRANCH_STOCK_MANAGER'])
                "
                @keydown="allowOnlyNumber($event)"
                @blur="onBlurProductAmount(row.item)"
                :class="{
                  'is-invalid':
                    $v.drugStockBinding.$each[row.index] &&
                    $v.drugStockBinding.$each[row.index].productAmount.$error,
                }"
              ></b-form-input>
            </template>

            <template v-slot:cell(productUnit)="row">
              <span :class="{ 'text-muted': !row.item.productNoAndName }">
                {{ row.item.productNoAndName ? row.item.productUnit : "???" }}
              </span>
            </template>

            <template v-slot:cell(buttons)="row">
              <button
                type="button"
                class="delete-btn"
                @click="deleteTreatmentStockBinding(row.index)"
                :disabled="!isAccessMenu(['ROLE_BRANCH_STOCK_MANAGER'])"
              >
                <i class="fas fa-trash-alt"></i>
              </button>
            </template>
          </b-table>
        </template>
        <b-button
          type="button"
          variant="outline-primary"
          class="button-width"
          @click="addDrugsStockBinding"
          :disabled="!isAccessMenu(['ROLE_BRANCH_STOCK_MANAGER'])"
        >
          <i class="fas fa-plus"></i> เพิ่มรายการสินค้า
        </b-button>
      </div>

      <div
        :class="{
          'hidden-btn-medicine-form':
            isAccessMenu(['ROLE_STOCK_STAFF']) &&
            !isHeadCounterOrManager &&
            !isAccessMenu(['ROLE_BRANCH_STOCK_MANAGER']),
        }"
      >
        <hr />
        <b-row class="d-flex flex-row-reverse">
          <div>
            <b-button class="ml-2 mr-3" type="submit" variant="primary">{{
              itemItem.id ? "แก้ไขรายการ" : "สร้างรายการ"
            }}</b-button>
          </div>
          <div>
            <b-button
              variant="danger"
              v-if="
                itemItem.id &&
                (!isAccessMenu([
                  'ROLE_BRANCH_STOCK_MANAGER',
                  'ROLE_STOCK_STAFF',
                ]) ||
                  isAccessMenu(['MANAGER', 'HEADCOUNTER']))
              "
              @click="deleteDrugsItem(itemItem)"
              >ลบรายการ</b-button
            >
          </div>
        </b-row>
      </div>
    </b-form>
    <Dialog ref="Dialog"></Dialog>
    <CateManage
      ref="DrugsCateItem"
      title="ประเภทยาและสินค้า"
      :categoryList="getItemCateList"
      :createCategoryFn="createItemCate"
      :deleteCategoryFn="deleteItemCate"
      :updateCategoryFn="updateItemCate"
      :fetchCategoryFn="fetchItemCateList"
    />
    <Loading v-if="isLoading"></Loading>
  </b-modal>
</template>

<script>
import Dialog from "@/components/modal/Dialog";
import CateManage from "@/components/modal/CateManage";
import Loading from "@/components/Loading";
import { mapActions, mapGetters } from "vuex";
import "@/theme/modal/AptItem.scss";
import {
  required,
  requiredIf,
  numeric,
  minLength,
  between,
  sameAs,
  not,
  helpers,
  email,
} from "vuelidate/lib/validators";

export default {
  name: "ItemItemModal",
  components: {
    Dialog,
    Loading,
    CateManage,
  },
  data() {
    return {
      isLoading: false,
      itemItem: {
        id: null,
        code: "",
        nameTh: "",
        nameEn: "",
        cateId: null,
        price: 0,
        unitName: null,
        favorite: false,
        df: null,
        dfType: 0,
        dfItem: [],
      },
      drugStockBinding: [],
      fields: [
        {
          key: "index",
          label: "",
          thStyle: { width: "6%" },
          tdStyle: { width: "6%" },
        },
        {
          key: "productNoAndName",
          label: "สินค้า",
          thStyle: { width: "45%" },
          tdStyle: { width: "45%" },
        },
        {
          key: "productAmount",
          label: "จำนวนสินค้า",
          thStyle: { width: "22%" },
          tdStyle: { width: "22%" },
        },

        {
          key: "productUnit",
          label: "หน่วยสินค้า",
          thStyle: { width: "20%" },
          tdStyle: { width: "20%" },
          tdClass: "text-wrap-cell",
        },
        {
          key: "buttons",
          label: "",
          thStyle: { width: "7%" },
          tdStyle: { width: "7%" },
        },
      ],
    };
  },
  validations: {
    itemItem: {
      nameTh: { required },
      cateId: { required },
      unitName: { required },
      price: { required },
      df: { required },
    },
    drugStockBinding: {
      $each: {
        productNoAndName: {
          required(value) {
            return !!(value && value.id);
          },
        },
        productAmount: {
          required(value, row) {
            if (!row || !row.productNoAndName || !row.productNoAndName.id)
              return true;
            return value != null && Number(value) !== 0;
          },
        },
      },
    },
  },
  computed: {
    ...mapGetters({
      getItemCateList: "moduleAppointment/getItemCateList",
      getUserList: "moduleUser/getUserList",
      getUserListBy: "moduleUser/getUserListBy",
      branchInfo: "moduleUser/getBranchInfo",
      isAccessMenu: "moduleUser/getIsAccessMenu",
    }),
    productOptions() {
      return this.productList.map(product => ({
        id: product.productId,
        name: `${product.productCode} - ${product.productNameMain}`,
      }));
    },
    isHeadCounterOrManager() {
      return this.isAccessMenu(["MANAGER", "HEADCOUNTER"]);
    },
  },
  watch: {},
  methods: {
    ...mapActions({
      createItemCate: "moduleAppointment/createItemCate",
      updateItemCate: "moduleAppointment/updateItemCate",
      deleteItemCate: "moduleAppointment/deleteItemCate",
      fetchItemCateList: "moduleAppointment/fetchItemCateList",
    }),
    init() {},
    show(data) {
      this.$bvModal.show("ItemItemModal");
      const { itemItem, productList } = data;
      this.productList = productList;
      if (itemItem) {
        this.isLoading = true;
        this.$store
          .dispatch("moduleAppointment/findItemListById", {
            event: itemItem,
            clinicUrl: this.$route.params.clinicUrl,
            branchUrl: this.$route.params.branchUrl,
          })
          .then(res => {
            if (res.status == 200) {
              this.itemItem = Object.assign({}, res.data);
              this.$bvModal.show("ItemItemModal");

              if (res.data.products && res.data.products.length > 0) {
                this.drugStockBinding = res.data.products.map(p => ({
                  productNoAndName: {
                    id: p.productId,
                    name:
                      `${p.product?.no || ""} - ${
                        p.product?.description || ""
                      }`.trim() || "Unknown",
                  },
                  productAmount: p.qty,
                  productUnit: p.product?.baseUom?.description || "???",
                }));
              } else {
                this.drugStockBinding = [];
              }
            }
            this.isLoading = false;
          })
          .finally(() => {
            this.setDfItem();
          });
      } else {
        this.setDfItem();
      }
    },
    saveDrugsItem() {
      this.$v.$touch();

      if (this.drugStockBinding.length === 0) {
        this.$v.drugStockBinding.$reset();
      }

      if (this.$v.$invalid) {
        return;
      }

      const products = this.drugStockBinding.map(item => {
        return {
          productId: item.productNoAndName.id,
          qty: Number(item.productAmount),
        };
      });

      this.isLoading = true;

      delete this.itemItem.del;
      this.itemItem.dfItem = this.itemItem.dfItem.filter(i => i.dfActive);

      if (!this.itemItem.id) {
        delete this.itemItem.id;
        this.$store
          .dispatch("moduleAppointment/createItemList", {
            event: {
              ...this.itemItem,
              products,
            },
            clinicUrl: this.$route.params.clinicUrl,
            branchUrl: this.$route.params.branchUrl,
          })
          .then(res => {
            if (res.status == "200") {
              this.$parent.showDialogToast(
                "success",
                `สร้างรายการ "${this.itemItem.nameTh}" สำเร็จ`
              );
            }
            this.isLoading = false;
          })
          .finally(() => {
            this.isLoading = false;
            this.$bvModal.hide("ItemItemModal");
            this.setDefaultValue();
          });
      } else {
        this.$store
          .dispatch("moduleAppointment/updateItemList", {
            event: {
              ...this.itemItem,
              products,
            },
            clinicUrl: this.$route.params.clinicUrl,
            branchUrl: this.$route.params.branchUrl,
          })
          .then(res => {
            this.$parent.showDialogToast(
              "success",
              `แก้ไขรายการ "${this.itemItem.nameTh}" สำเร็จ`
            );
          })
          .finally(() => {
            this.isLoading = false;
            this.$bvModal.hide("ItemItemModal");
          });
      }
    },
    deleteDrugsItem(eventData) {
      this.$refs.Dialog.showAlertConfirm(
        "ลบการรักษานี้ ?",
        "คุณต้องการลบการรักษานี้"
      ).then(result => {
        if (result.value) {
          this.isLoading = true;
          this.$store
            .dispatch("moduleAppointment/deleteItemList", {
              event: eventData,
              clinicUrl: this.$route.params.clinicUrl,
              branchUrl: this.$route.params.branchUrl,
            })
            .then(res => {
              if (res.status == "200") {
                this.setDefaultValue();
                this.$parent.showDialogToast(
                  "success",
                  `ลบรายการ "${eventData.nameTh}" สำเร็จ`
                );
              }
              this.isLoading = false;
            })
            .catch(() => {
              this.isLoading = false;
              this.$parent.showDialogToast(
                "warning",
                `ลบรายการ "${eventData.nameTh}" ไม่สำเร็จ`
              );
            })
            .finally(() => {
              this.$bvModal.hide("ItemItemModal");
            });
        }
      });
    },
    setDfItem() {
      this.getUserList.forEach(user => {
        let dfItem = {
          id: null,
          uid: user.uid,
          df: null,
          dfActive: false, // เพิ่มให้สามารถเปิดปิดเฉพาะคนได้
        };
        let index = this.itemItem.dfItem.findIndex(dfSpec => {
          return dfSpec.uid == user.uid;
        });
        if (index < 0) {
          this.itemItem.dfItem.push(dfItem);
        } else {
          this.$set(this.itemItem.dfItem[index], "dfActive", true); // ให้เปิดใช้ในกรณีที่มี df เฉพาะ
        }
      });
    },
    close() {
      this.$v.$reset();
      this.setDefaultValue();
    },
    setDefaultValue() {
      this.itemItem = Object.assign(
        {},
        {
          id: null,
          code: "",
          nameTh: "",
          nameEn: "",
          cateId: null,
          price: 0,
          unitName: null,
          favorite: false,
          df: null,
          dfType: 0,
          dfItem: [],
        }
      );
      this.drugStockBinding = [];
    },
    openDrugsCateItem() {
      this.$refs.DrugsCateItem.show();
    },
    validateDf(df) {
      if (this.itemItem.dfType == 0) {
        if (df > 100) {
          this.itemItem.df = 100;
        }
      } else {
        if (df > this.itemItem.price) {
          this.itemItem.df = this.itemItem.price;
        }
      }
    },
    validateDfItem(dfSpec, index) {
      if (this.itemItem.dfType == 0) {
        if (dfSpec.df > 100) {
          dfSpec.df = 100;
        }
      } else {
        if (dfSpec.df > this.itemItem.price) {
          dfSpec.df = this.itemItem.price;
        }
      }
    },
    activateDfSpec(dfSpec) {
      if (!dfSpec.dfActive) {
        dfSpec.df = null;
      }
    },
    getProductOptions(currentIndex) {
      const selectedInOtherRows = new Set(
        this.drugStockBinding
          .map((item, i) =>
            i !== currentIndex && item.productNoAndName?.id
              ? item.productNoAndName.id
              : null
          )
          .filter(Boolean)
      );
      return this.productOptions.filter(
        product => !selectedInOtherRows.has(product.id)
      );
    },
    createEmptyDrugsStockBinding() {
      return {
        productNoAndName: "",
        productAmount: null,
        productUnit: "???",
      };
    },
    addDrugsStockBinding() {
      const wasEmpty = this.drugStockBinding.length === 0;

      this.drugStockBinding.push(this.createEmptyDrugsStockBinding());

      if (wasEmpty) {
        this.$nextTick(() => {
          this.$v.drugStockBinding.$reset();
        });
      }
    },
    deleteTreatmentStockBinding(index) {
      this.drugStockBinding.splice(index, 1);
    },
    allowOnlyNumber(e) {
      const allowedKeys = [
        "Backspace",
        "Tab",
        "ArrowLeft",
        "ArrowRight",
        "Delete",
      ];
      if (allowedKeys.includes(e.key)) return;

      if (/^\d$/.test(e.key)) return;

      e.preventDefault();
    },
    onBlurProductAmount(item) {
      const raw = (item.productAmount || "").trim();
      if (raw === "") return;
      const num = parseInt(raw, 10);
      item.productAmount = isNaN(num) ? "0" : String(num);
    },
    onProductNoAndNameChange(row) {
      row.item.productAmount = null;
      if (row.item.productNoAndName?.id) {
        const product = this.productList.find(
          p => p.productId === row.item.productNoAndName.id
        );
        row.item.productUnit = product.productUnit.description;
      }

      const rowValidation = this.$v.drugStockBinding.$each?.[row.index];
      if (rowValidation?.productAmount?.$reset) {
        rowValidation.productAmount.$reset();
      }
    },
  },
};
</script>

<style scoped>
.required {
  background-color: #ccecff6c;
}

.display-column {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.button-width {
  width: 161px;
}

.button-width:disabled {
  background-color: #fff !important;
  color: #ebebeb !important;
  border-color: #ebebeb !important;
  cursor: not-allowed;
}

.label-title {
  font-size: 18px;
  font-weight: 600;
}

.label-description {
  font-size: 16px;
  font-weight: 400;
  color: #6d747d;
}

::v-deep .multiselect__tags {
  background-color: #ccecff6c;
  box-shadow: none;
}

::v-deep .multiselect__single,
::v-deep .multiselect__input,
::v-deep .multiselect__placeholder {
  background-color: transparent !important;
}

::v-deep span.multiselect__placeholder {
  margin-left: 6px !important;
}

::v-deep .multiselect__input,
::v-deep .multiselect__single {
  padding-left: 6px;
}

::v-deep span.multiselect__single {
  margin-left: 6px !important;
}

::v-deep .multiselect__single {
  margin-bottom: 0;
  padding-left: 0;
}

::v-deep .multiselect__tags {
  box-shadow: none;
}

::v-deep .multiselect--disabled {
  background-color: #ebebeb !important;
  color: #c6c6c6 !important;
  opacity: 1 !important;
  border: 1px solid #ced4da !important;
  border-radius: 4px;
  overflow: hidden;
}

::v-deep .multiselect--disabled .multiselect__tags {
  background-color: #ebebeb !important;
  cursor: not-allowed;
  overflow: hidden;
  color: #c6c6c6 !important;
  z-index: 1;
  position: relative;
  border: none !important;
}

::v-deep .multiselect--disabled .multiselect__placeholder {
  background-color: #ebebeb !important;
  color: #c6c6c6 !important;
}

::v-deep .multiselect--disabled .multiselect__select {
  background-color: #ebebeb !important;
  cursor: not-allowed;
  z-index: 0;
  overflow: hidden;
}

::v-deep #DrugStockBindingTable {
  margin-bottom: 0px !important;
}

::v-deep #DrugStockBindingTable tbody tr td {
  border-bottom: 1px solid #dee2e6 !important;
}

::v-deep #DrugStockBindingTable.table-hover tbody tr:hover {
  background-color: transparent !important;
}

::v-deep #DrugStockBindingTable thead tr th,
::v-deep #DrugStockBindingTable tbody tr td {
  /* text-align: center !important; */
  vertical-align: middle !important;
}

::v-deep #DrugStockBindingTable .bottom-row-cell {
  text-align: left !important;
}

::v-deep .btn-delete-adjustment:disabled {
  border-color: #dee2e6 !important;
  color: #dee2e6 !important;
}

::v-deep .form-control:disabled {
  background-color: #ebebeb !important;
  color: #c6c6c6 !important;
}

::v-deep #DrugStockBindingTable td.text-wrap-cell {
  word-break: break-word;
  overflow-wrap: break-word;
  white-space: normal;
}

::v-deep .delete-btn {
  background-color: transparent;
  border: 1px solid #dee2e6;
  border-radius: 4px;
  padding: 4px 8px;
  cursor: pointer;
  color: #a3a4a6;
  font-size: 20px;
  width: 48px;
  height: 38px;
}

.delete-btn:hover:not(:disabled) {
  background-color: #d33;
  color: #fff;
}

.delete-btn:disabled {
  border-color: #ebebeb !important;
  color: #ebebeb !important;
  cursor: not-allowed;
}

.product-no-and-name-wrapper {
  position: relative;
}

.invalid-icon-position {
  position: absolute;
  top: 47%;
  right: 32px;
  transform: translateY(-50%);
  color: #dc3545;
  width: 16px;
  height: 16px;
}

.icon-invalid-exclamation {
  background-image: url("~@/assets/icon/invalid-exclamation.svg");
  display: inline-block;
  width: 18px;
  height: 18px;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
}

.disabled-medicine-form {
  opacity: 0.5;
  pointer-events: none;
  cursor: not-allowed;
}

.hidden-btn-medicine-form {
  display: none;
}
</style>
